import { Mic, Database, ShieldCheck, Cpu, Waves } from "lucide-react";
import { SHELL } from "@/constants/testIds";

function Indicator({ label, Icon, color = "ok" }) {
  const dot = {
    ok: "bg-[hsl(var(--nn-ok))]",
    blue: "bg-[hsl(var(--nn-blue))]",
    amber: "bg-[hsl(var(--nn-amber))]",
  }[color];
  return (
    <div className="flex items-center gap-2 text-[11px] text-[hsl(var(--nn-ink-muted))]">
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      <Icon className="h-3.5 w-3.5 opacity-70" strokeWidth={1.6} />
      <span>{label}</span>
    </div>
  );
}

export default function StatusStrip() {
  return (
    <div
      data-testid={SHELL.statusStrip}
      className="relative z-10 mx-4 mb-2 flex h-8 items-center justify-between rounded-xl border border-white/[0.06] bg-black/20 px-4 backdrop-blur-md"
    >
      <div className="flex items-center gap-5">
        <Indicator label="Voice capture ready" Icon={Mic} color="ok" />
        <span className="h-3 w-px bg-white/10" />
        <Indicator label="Context indexed" Icon={Database} color="blue" />
        <span className="h-3 w-px bg-white/10" />
        <Indicator label="Provenance enabled" Icon={ShieldCheck} color="amber" />
      </div>
      <div className="flex items-center gap-4 text-[10.5px] font-mono text-[hsl(var(--nn-ink-faint))]">
        <span className="flex items-center gap-1.5">
          <Waves className="h-3 w-3" strokeWidth={1.6} /> latency 42ms
        </span>
        <span className="flex items-center gap-1.5">
          <Cpu className="h-3 w-3" strokeWidth={1.6} /> local · encrypted
        </span>
        <span>v0.4.2 · fellowship build</span>
      </div>
    </div>
  );
}
